import { Link } from 'lucide-react';

interface Props {
    url: string;
    previewImage: string;
    title: string;
    description: string;
}

const WebsitePreview: FC<Props> = ({ url, previewImage, title, description }) => {
    return (
        <a className="website-preview" href={url} target="_blank" rel="noreferrer">
            {previewImage ? <img src={previewImage} alt="" /> : <Link />}
            <div>
                <div className="title">{title}</div>
                <div className="description text-muted small">{description}</div>
            </div>
        </a>
    );
};

export default WebsitePreview;
